import styled from '@emotion/styled';

export const CustomFileUploderStyle = styled.div`
	display: flex;
	justify-content: center;
	gap: 16px;
	& h2 {
		font-size: 16px;
		font-weight: 600;
		text-align: center;
	}
	& button {
		font-weight: 600;
	}
	height: 320px;
	width: 100%;

	& > div {
		box-direction: normal !important;
		box-orient: vertical !important;
		width: 100% !important;
		flex: 1 1 100% !important;
		box-sizing: border-box !important;
		display: flex !important;
		flex-direction: column !important;
		z-index: 1 !important;

		[class^='dragArea'] {
			box-align: center !important;
			box-pack: center !important;
			box-direction: normal !important;
			box-orient: vertical !important;
			position: fixed !important;
			top: 0px !important;
			left: 0px !important;
			width: 100% !important;
			height: 100% !important;
			z-index: 3 !important;
			display: flex !important;
			flex-direction: column !important;
			background: rgba(255, 255, 255, 0.8) !important;
			justify-content: center !important;
			align-items: center !important;
			visibility: hidden !important;
			opacity: 0 !important;
			transition: opacity 0.4s linear 0s, visibility 0s linear 0.4s !important;
		}

		[class^='inputStyles'] {
			height: 0px !important;
			width: 0px !important;
			visibility: hidden !important;
			position: absolute !important;
		}
	}
`;
